import MfgInquiry from 'src/components/ConnectedVehicle/MfgInquiry/MfgInquiry';
import { connect } from 'react-redux';
import { IStoreState } from 'src/store';
import { ConnectedVehicleActionCreator } from 'src/store/states';

const mapStateToProps = (state: IStoreState) => ({
    connectedVehicle: state.ConnectedVehicle.ConnectedVehicleRec,
});

const mapDispatchToProps = {
    displayMfgInquiry: ConnectedVehicleActionCreator.DisplayMfgInquiry,
};

export default connect(mapStateToProps, mapDispatchToProps)(MfgInquiry);